// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/initial-contact-and-circuit-clearance.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/initial-contact-and-circuit-clearance/initial-contact-and-circuit-clearance.js';

mount([g0]);
